import { Pipe, PipeTransform } from '@angular/core';
import { LoopBackAuth, LoopBackConfig } from '@careapp/angular-sdk';

@Pipe({
  name: 'filedownloadurl'
})
export class FileDownloadUrlPipe implements PipeTransform {
  constructor(private auth?: LoopBackAuth) {}

  public transform(object) {
    if (!object) return '';
    if (Array.isArray(object)) {
      return object.map(file => this.getDownloadUrl(file));
    }
    return this.getDownloadUrl(object);
  }

  getDownloadUrl(file) {
    const fileId = file.id;
    const query = this.auth ? `?access_token=${this.auth.getAccessTokenId()}` : '';
    const host = LoopBackConfig.getPath() + '/' + LoopBackConfig.getApiVersion();

    return `${host}/files/${fileId}/download${query}`;
  }
}
